import React from "react";

const SomeSpace = () => {
  return <div className="h-16 md:hidden"></div>;
};

export default SomeSpace;
